import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useAppStore } from '@/store'
import { storeToRefs } from 'pinia'
import Menu from '@/layout/components/menu.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'sidebar-section',
  setup(__props) {

const app = useAppStore()

const { sidebarStatus, mobileScreenMode } = storeToRefs(app)

const collapsed = computed(() => sidebarStatus.value === 'close')
const onCollapse = (val: boolean, type: string) => {
  if (type === 'clickTrigger') {
    sidebarStatus.value = val ? 'close' : 'open'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!

  return (_openBlock(), _createBlock(_component_a_layout_sider, {
    breakpoint: "lg",
    width: 220,
    collapsible: "",
    collapsed: collapsed.value,
    onCollapse: onCollapse,
    class: "sidebar-section"
  }, {
    default: _withCtx(() => [
      _createVNode(Menu)
    ]),
    _: 1
  }, 8, ["collapsed"]))
}
}

})